<ng-container *ngIf="elerheto">
  <button type="button" class="konrad-gomb" [class.nyitva]="nyitva" (click)="nyit()" title="Konrád nyuszi – kérdezz bátran!">
    <img [src]="arc" alt="" draggable="false">
  </button>

  <section class="konrad-ablak" *ngIf="nyitva" role="dialog" aria-label="Konrád nyuszi">
    <header>
      <img class="fej-arc" [src]="arc" alt="">
      <div class="cim"><b>Konrád nyuszi</b><small>kérdezz, és segítek a programban</small></div>
      <button type="button" class="ikon" (click)="uj()" title="Új beszélgetés (a futó válasz megszakad)"><ion-icon name="refresh-outline"></ion-icon></button>
      <button type="button" class="ikon" (click)="nyit()" title="Félreteszem (a beszélgetés megmarad)"><ion-icon name="remove-outline"></ion-icon></button>
      <button type="button" class="ikon" (click)="bezar()" title="Bezárás (a beszélgetés törlődik)"><ion-icon name="close-outline"></ion-icon></button>
    </header>

    <div class="lista" #lista>
      <div class="udv" *ngIf="!uzenetek.length">
        <img class="udv-arc" [src]="kepek.vidam" alt="">
        <p>{{ udvozles }}</p>
        <button type="button" class="javaslat" *ngFor="let j of javaslatok" (click)="kuld(j)">{{ j }}</button>
      </div>

      <div *ngFor="let u of uzenetek" class="uzenet" [class.sajat]="u.szerep === 'user'" [class.hiba]="u.hiba">
        <div class="sor">
          <img *ngIf="u.szerep === 'assistant'" class="mini" [src]="u.hiba ? kepek.csodalkozik : (u === elo ? kepek.gondolkodik : kepek.vidam)" alt="">
          <div class="buborek" [innerHTML]="formaz(u.szoveg)"></div>
        </div>

        <div class="kartya" *ngFor="let k of u.kartyak" [class.kesz]="k.allapot === 'kesz'" [class.elvetve]="k.allapot === 'elvetve'" [class.rossz]="k.allapot === 'hiba'">
          <div class="kartya-cim"><ion-icon name="create-outline"></ion-icon>{{ k.osszegzes }}</div>
          <div class="kartya-gombok" *ngIf="k.allapot === 'fuggo' || k.allapot === 'fut'">
            <button type="button" class="fo" [disabled]="k.allapot === 'fut'" (click)="jovahagy(k)">
              <ion-icon name="checkmark-outline"></ion-icon>{{ k.allapot === 'fut' ? 'Mentés…' : 'Jóváhagyás' }}</button>
            <button type="button" [disabled]="k.allapot === 'fut'" (click)="elvet(k)">Elvetés</button>
          </div>
          <div class="kartya-allapot" *ngIf="k.allapot === 'kesz' || k.allapot === 'hiba'">{{ k.uzenet }}</div>
          <div class="kartya-allapot" *ngIf="k.allapot === 'elvetve'">Elvetve.</div>
        </div>

        <button type="button" class="vigyel" *ngIf="u.ujrakerdez" [disabled]="fut" (click)="ujraKerdez(u)">
          <ion-icon name="refresh-outline"></ion-icon>Kérdezd újra</button>
        <button type="button" class="vigyel" *ngFor="let n of u.navigacio" (click)="odamegy(n)">
          <ion-icon name="navigate-outline"></ion-icon>Vigyél oda: {{ n.cim }}</button>
      </div>

      <!-- Amíg dolgozik: a pontok, amíg nincs szöveg (vagy épp utánanéz valaminek); a folyamatosan
           íródó válasz maga a buborék fent. -->
      <div class="uzenet" *ngIf="fut && (!elo || eszkozJel)"><div class="sor"><img class="mini" [src]="kepek.gondolkodik" alt=""><div class="buborek gondolkodik"><span></span><span></span><span></span></div>
        <span class="eszkoz-jel" *ngIf="eszkozJel">{{ eszkozJel }}</span></div></div>
    </div>

    <footer>
      <textarea rows="1" [(ngModel)]="kerdes" (keydown)="billentyu($event)" placeholder="Kérdezz Konrádtól…" [disabled]="fut"></textarea>
      <button type="button" class="kuld" (click)="kuld()" [disabled]="fut || !kerdes.trim()" title="Küldés"><ion-icon name="send"></ion-icon></button>
    </footer>
  </section>
</ng-container>
